import React, { useEffect, useState } from 'react';
import Layout from '../../Components/Layout';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import toast from 'react-hot-toast';

const WorkOrderCreate = () => {

    const location = useLocation();

    const isEdit = location.state?.isEdit || false;

    const orderId = location.state?.orderId || null;


    const [customerList, setCustomerList] = useState([]);
    const [errors, setErrors] = useState({});



    const [workOrder, setWorkOrder] = useState({
        referenceOrderNumber: "",
        orderDate: "",
        orderFor: "",
        taxType: "",


        supplierName: "",

        organizationName: "",
        gstNumber: "",
        email: "",
        phoneNumber: "",
        firstName: "",
        faxNo: "",
        gstNumber: "",

        billTo: "",
        shipTo: "",
        contactPerson: "",

        items: [
            {
                description: "",
                quantity: "",
                unitPrice: "",
                discount: ""
            }
        ]
    });

    const fetchCustomers = async () => {

        try {

            const token = localStorage.getItem("token");

            const response = await axios.get(
                `${process.env.REACT_APP_BACKEND_URL}/trading-partner?page=0&size=100`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            setCustomerList(response.data.content);

        } catch (error) {

            console.log(error);

            toast.error("Failed To Fetch Customers");
        }
    };

    const fetchOrderById = async () => {

        try {

            const token =
                localStorage.getItem("token");

            const response =
                await axios.get(
                    `${process.env.REACT_APP_BACKEND_URL}/orders/${orderId}`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );

            const data = response.data;

            setWorkOrder({

                referenceOrderNumber:
                    data.referenceOrderNumber || "",

                orderDate:
                    data.orderDate || "",

                orderFor:
                    data.orderFor || "",

                taxType:
                    data.gstType || "",

                firstName:
                    data.firstName || "",

                organizationName:
                    data.organizationName || "",

                gstNumber:
                    data.gstNumber || "",

                email:
                    data.email || "",

                phoneNumber:
                    data.mobileNumber || "",

                billTo:
                    `${data.address?.streetLine1 || ""}
                 ${data.address?.streetLine2 || ""}
                 ${data.address?.city || ""}
                 ${data.address?.state || ""}
                 ${data.address?.postalCode || ""}`,

                items:
                    data.items.map(item => ({

                        itemId:
                            item.itemId,

                        description:
                            item.description,

                        quantity:
                            item.quantity,

                        unitPrice:
                            item.unitPrice,

                        discount:
                            item.discount

                    }))
            });

        } catch (error) {

            console.log(error);

            toast.error(
                "Failed To Fetch Order"
            );
        }
    };

    // ================= VALIDATION FUNCTION =================
    const validateForm = () => {
        const newErrors = {};

        // Reference Order Number Validation
        if (!workOrder.referenceOrderNumber || workOrder.referenceOrderNumber.trim() === "") {
            newErrors.referenceOrderNumber = "Reference Order Number is required";
        }

        // Order Date Validation
        if (!workOrder.orderDate || workOrder.orderDate.trim() === "") {
            newErrors.orderDate = "Order Date is required";
        }

        // Order For (Customer) Validation
        if (!workOrder.orderFor || workOrder.orderFor === "") {
            newErrors.orderFor = "Please select an organization";
        }


        // Items Validation
        if (workOrder.items && workOrder.items.length > 0) {
            workOrder.items.forEach((item, index) => {
                if (!item.description || item.description.trim() === "") {
                    newErrors[`description_${index}`] = "Description is required";
                }
                if (!item.quantity || item.quantity <= 0) {
                    newErrors[`quantity_${index}`] = "Valid quantity is required";
                }
                if (!item.unitPrice || item.unitPrice <= 0) {
                    newErrors[`unitPrice_${index}`] = "Valid unit price is required";
                }
            });
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    useEffect(() => {

        fetchCustomers();

        if (isEdit && orderId) {

            fetchOrderById();
        }

    }, []);


    // Main Input Change
    const handleChange = (e) => {

        const { name, value } = e.target;

        setWorkOrder({
            ...workOrder,
            [name]: value
        });
        // Clear error for this field when user starts typing
        if (errors[name]) {
            setErrors({ ...errors, [name]: "" });
        }
    };

    const handleOrganizationChange = (e) => {

        const tradingPartnerId = Number(e.target.value);

        const customer = customerList.find(
            item => item.tradingPartnerId === tradingPartnerId
        );

        if (!customer) return;

        setWorkOrder(prev => ({
            ...prev,

            orderFor: customer.tradingPartnerId,
            firstName: customer.firstName || "",

            organizationName:
                customer.organizationName || "",

            taxType:
                customer.gstType || "",

            gstNumber:
                customer.gstNumber || "",

            email:
                customer.email || "",

            phoneNumber:
                customer.mobileNumber || "",

            billTo:
                `${customer.address?.streetLine1 || ""}
             ${customer.address?.streetLine2 || ""}
             ${customer.address?.city || ""}
             ${customer.address?.state || ""}
             ${customer.address?.postalCode || ""}`,

            shipTo:
                `${customer.address?.streetLine1 || ""}
             ${customer.address?.streetLine2 || ""}
             ${customer.address?.city || ""}
             ${customer.address?.state || ""}
             ${customer.address?.postalCode || ""}`
        }));
        // Clear orderFor error
        if (errors.orderFor) {
            setErrors({ ...errors, orderFor: "" });
        }
    };

    // Dynamic Table Input Change
    const handleItemChange = (
        index,
        field,
        value
    ) => {

        const updatedItems = [
            ...workOrder.items
        ];

        updatedItems[index][field] = value;

        setWorkOrder({
            ...workOrder,
            items: updatedItems
        });
        // Clear error for this field
        if (errors[`${field}_${index}`]) {
            setErrors({ ...errors, [`${field}_${index}`]: "" });
        }
    };

    // Add Row
    const addMoreRow = () => {

        setWorkOrder({
            ...workOrder,
            items: [
                ...workOrder.items,
                {
                    description: "",
                    quantity: "",
                    unitPrice: "",
                    discount: ""
                }
            ]
        });

    };

    // Remove Row
    const removeRow = (index) => {

        if (workOrder.items.length === 1) {
            toast.error("At least one item is required");  // ADD THIS
            return;  // ADD THIS
        }

        const updatedItems =
            workOrder.items.filter(
                (_, i) => i !== index
            );

        setWorkOrder({
            ...workOrder,
            items: updatedItems
        });
    };

    const handleCreateWorkOrder = async () => {

        // ADD THIS VALIDATION CHECK
        if (!validateForm()) {
            toast.error("Please fill all required fields correctly");
            return;
        }


        try {

            const token = localStorage.getItem("token");


            const payload = {

                referenceOrderNumber:
                    workOrder.referenceOrderNumber,

                orderDate:
                    workOrder.orderDate,

                orderFor:
                    Number(workOrder.orderFor),

                taxType:
                    workOrder.taxType,

                subTotal:
                    Number(subtotal),

                igst:
                    Number(igst),

                cgst:
                    Number(cgst),

                sgst:
                    Number(sgst),

                total:
                    Number(total),
                /*
                                items:
                                    workOrder.items.map(item => ({
                
                                        description:
                                            item.description,
                
                                        itemDate:
                                            workOrder.orderDate,
                
                                        unitPrice:
                                            Number(item.unitPrice),
                
                                        quantity:
                                            Number(item.quantity),
                
                                        discount:
                                            Number(item.discount || 0),
                
                                        price:
                                            (Number(item.quantity || 0) *
                                                Number(item.unitPrice || 0))
                                            - Number(item.discount || 0)
                
                                    }))
                                            */
                items:
                    workOrder.items.map(item => ({

                        itemId:
                            item.itemId,

                        description:
                            item.description,

                        itemDate:
                            workOrder.orderDate,

                        unitPrice:
                            Number(item.unitPrice),

                        quantity:
                            Number(item.quantity),

                        discount:
                            Number(item.discount || 0),

                        price:
                            (Number(item.quantity || 0) *
                                Number(item.unitPrice || 0))
                            - Number(item.discount || 0)

                    }))
            };

            console.log(
                "Selected Customer Id =>",
                workOrder.orderFor
            );

            console.log(
                "Payload =>",
                payload
            );

            if (isEdit) {

                await axios.patch(
                    `${process.env.REACT_APP_BACKEND_URL}/orders/${orderId}`,
                    payload,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json"
                        }
                    }
                );

                toast.success(
                    "Work Order Updated Successfully"
                );

            } else {

                await axios.post(
                    `${process.env.REACT_APP_BACKEND_URL}/orders`,
                    payload,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json"
                        }
                    }
                );

                toast.success(
                    "Work Order Created Successfully"
                );
            }



            navigate(
                "/work-orderlist"
            );

        } catch (error) {

            console.log(error);

            toast.error(
                "Failed To Create Work Order"
            );
        }
    };

    // Total Calculation
    const subtotal =
        workOrder.items.reduce(
            (total, item) => {

                const quantity =
                    Number(item.quantity || 0);

                const unitPrice =
                    Number(item.unitPrice || 0);

                const discount =
                    Number(item.discount || 0);

                return (
                    total +
                    quantity * unitPrice -
                    discount
                );
            },
            0
        );

    const gstType = workOrder.taxType?.trim();

    let igst = 0;
    let cgst = 0;
    let sgst = 0;

    if (gstType === "INTER_STATE") {

        igst = subtotal * 0.18;

    } else if (gstType === "INTRA_STATE") {

        cgst = subtotal * 0.09;
        sgst = subtotal * 0.09;
    }

    const total =
        subtotal +
        igst +
        cgst +
        sgst;
    const navigate = useNavigate();

    return (
        <Layout>

            <div className="backgound-main-content py-4">

                <div className="container-fluid">
                    <button
                        className="btn btn-primary"
                        onClick={() => navigate(-1)}
                    >
                        Back
                    </button>

                    <div
                        className="bg-white border p-3 mt-2"
                        style={{
                            maxWidth: '1100px',
                            margin: '0 auto',
                        }}
                    >

                        {/* Header */}
                        <div className="text-center border-bottom pb-2">

                            <h2 className="fw-bold mb-1">
                                RAK SOFTECH PRIVATE LTD
                            </h2>

                            <p className="mb-0">
                                Office no 3, 3rd floor, Mayuri plaza,
                                above SBI, Near Bhoir Hospital,
                                Dange Chowk, Chinchwad Pune 411033
                            </p>

                            <p className="mb-0">
                                email: kavitay@raksoftech.com
                                | Ph: 91-9588614798
                            </p>

                        </div>

                        {/* GST */}
                        <div className="row border border-top-0 m-0">

                            <div className="col-md-6 border-end py-2 fw-bold">
                                GSTIN No -{workOrder.gstNumber}
                            </div>

                            <div className="col-md-6 py-2 text-center fw-bold">
                                GST INVOICE
                            </div>

                        </div>

                        {/* Invoice Details */}
                        <div className="row border border-top-0 m-0">

                            <div className="col-md-6 py-2">


                                <div className="mb-2">
                                    <label className="fw-bold">
                                        First Name
                                    </label>

                                    <input
                                        type="text"
                                        className="form-control"
                                        name="firstName"
                                        value={workOrder.firstName}
                                        onChange={handleChange}
                                    />
                                </div>


                                {/* Organization Name  */}
                                <div className="row mt-2">
                                    <div className="col-md-6">
                                        <label className="fw-bold">
                                            Organization Name <span className="text-danger">*</span>  {/* ADD asterisk */}
                                        </label>
                                        <select
                                            className={`form-select ${errors.orderFor ? 'is-invalid' : ''}`}
                                            name="orderFor"
                                            value={workOrder.orderFor}
                                            onChange={handleOrganizationChange}
                                        >
                                            <option value="">Select Organization</option>
                                            {customerList.map(customer => (
                                                <option key={customer.tradingPartnerId} value={customer.tradingPartnerId}>
                                                    {customer.organizationName}
                                                </option>
                                            ))}
                                        </select>
                                        {errors.orderFor && (
                                            < div className="invalid-feedback">{errors.orderFor}</div>
                                        )}
                                    </div>
                                    <div className="col-md-6">
                                        <label className="fw-bold">
                                            Reference Order Number <span className="text-danger">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            name="referenceOrderNumber"
                                            className={`form-control ${errors.referenceOrderNumber ? 'is-invalid' : ''}`}
                                            value={workOrder.referenceOrderNumber}
                                            onChange={handleChange}
                                        />
                                        {errors.referenceOrderNumber && (
                                            < div className="invalid-feedback">{errors.referenceOrderNumber}</div>
                                        )}
                                    </div>
                                </div>
                                <div className="row mt-2">

                                    {/* Tenant Name */}
                                    <div className="col-md-6">

                                        <label className="fw-bold">
                                            Phone Number
                                        </label>

                                        <input
                                            type="text"
                                            className="form-control"
                                            value={workOrder.phoneNumber}

                                        />

                                    </div>


                                    <div className="col-md-6">
                                        <label className="fw-bold">
                                            Email
                                        </label>

                                        <input
                                            type="text"
                                            className="form-control"
                                            name="email"
                                            value={workOrder.email || ""}
                                            onChange={handleChange}
                                        />
                                    </div>

                                </div>

                            </div>

                            <div className="col-md-6 py-2">

                                <div className="mb-2">
                                    <label className="fw-bold">
                                        Date <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="date"
                                        className={`form-control ${errors.orderDate ? 'is-invalid' : ''}`}
                                        name="orderDate"
                                        value={workOrder.orderDate}
                                        onChange={handleChange}
                                    />
                                    {errors.orderDate && (
                                        < div className="invalid-feedback">{errors.orderDate}</div>
                                    )}
                                </div>



                            </div>

                        </div>

                        {/* Address */}
                        <div className="row border border-top-0 m-0">

                            <div className="col-md-6 border-end py-2">

                                <label className="fw-bold">
                                    Bill To
                                </label>

                                <textarea
                                    rows="4"
                                    className="form-control"
                                    name="billTo"
                                    value={workOrder.billTo}
                                    onChange={handleChange}
                                />

                            </div>



                        </div>

                        {/* Table */}
                        <div className="table-responsive mt-3">

                            <table className="table table-bordered align-middle mb-0">

                                <thead className="table-light text-center">
                                    <tr>
                                        <th width="8%">Item #</th>
                                        <th width="35%">Description <span className="text-danger">*</span></th>  {/* ADD asterisk */}
                                        <th width="10%">Qty <span className="text-danger">*</span></th>  {/* ADD asterisk */}
                                        <th width="12%">Unit Price <span className="text-danger">*</span></th>  {/* ADD asterisk */}
                                        <th width="10%">Discount</th>
                                        <th width="15%">Price</th>
                                        <th width="10%">Action</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {workOrder.items.map((item, index) => {
                                        const rowTotal = Number(item.quantity || 0) * Number(item.unitPrice || 0) - Number(item.discount || 0);
                                        return (
                                            <tr key={index}>
                                                <td className="text-center">
                                                    {index + 1}
                                                </td>

                                                <td>
                                                    <textarea
                                                        rows="2"
                                                        className={`form-control ${errors[`description_${index}`] ? 'is-invalid' : ''}`}
                                                        placeholder="Description"
                                                        value={item.description}
                                                        onChange={(e) => handleItemChange(index, "description", e.target.value)}
                                                    />
                                                    {errors[`description_${index}`] && (
                                                        <div className="invalid-feedback">{errors[`description_${index}`]}</div>
                                                    )}
                                                </td>

                                                <td>
                                                    <input

                                                        className={`form-control ${errors[`quantity_${index}`] ? 'is-invalid' : ''}`}
                                                        placeholder="Qty"
                                                        value={item.quantity || ""}
                                                        onChange={(e) => handleItemChange(index, "quantity", e.target.value)}
                                                    />
                                                    {errors[`quantity_${index}`] && (
                                                        <div className="invalid-feedback">{errors[`quantity_${index}`]}</div>
                                                    )}
                                                </td>

                                                <td>
                                                    <input

                                                        className={`form-control ${errors[`unitPrice_${index}`] ? 'is-invalid' : ''}`}
                                                        placeholder="Unit Price"
                                                        value={item.unitPrice || ""}
                                                        onChange={(e) => handleItemChange(index, "unitPrice", e.target.value)}
                                                    />
                                                    {errors[`unitPrice_${index}`] && (
                                                        <div className="invalid-feedback">{errors[`unitPrice_${index}`]}</div>
                                                    )}
                                                </td>

                                                <td>
                                                    <input

                                                        className="form-control"
                                                        placeholder="Discount"
                                                        value={item.discount || ""}
                                                        onChange={(e) => handleItemChange(index, "discount", e.target.value)}
                                                    />
                                                </td>

                                                <td className="text-end fw-bold">
                                                    ₹ {rowTotal.toFixed(2)}
                                                </td>

                                                <td className="text-center">
                                                    <button
                                                        type="button"
                                                        className="btn btn-danger btn-sm"
                                                        onClick={() => removeRow(index)}
                                                    >
                                                        Remove
                                                    </button>
                                                </td>
                                            </tr>
                                        );
                                    })}

                                    {/* Terms & Conditions + Summary */}
                                    <tr>
                                        <td
                                            colSpan="5"
                                            rowSpan={workOrder.taxType === "INTER_STATE" ? 3 : 4}
                                            className="align-top"
                                        >
                                            <h6 className="fw-bold">Terms and Conditions</h6>
                                            <ol className="ps-3 mb-0">
                                                <li>Supplier has to confirm PO to be duly signed by authorized signatory.</li>
                                                <li>Payment terms will be as per agreement with 45 / 60 / 90 days cycle.</li>
                                                <li>All payment will be done through NEFT / RTGS.</li>
                                                <li>Invoice due date between payroll dates will be credited in next payroll.</li>
                                                <li>Cancellation of services or PO will be informed via email.</li>
                                            </ol>
                                        </td>

                                        <td className="fw-bold text-end">
                                            Sub Total
                                        </td>

                                        <td className="text-end">
                                            ₹ {subtotal.toFixed(2)}
                                        </td>
                                    </tr>

                                    {workOrder.taxType === "INTER_STATE" ? (
                                        <tr>
                                            <td className="fw-bold text-end">
                                                IGST (18%)
                                            </td>
                                            <td className="text-end">
                                                ₹ {igst.toFixed(2)}
                                            </td>
                                        </tr>
                                    ) : (
                                        <>
                                            <tr>
                                                <td className="fw-bold text-end">
                                                    CGST (9%)
                                                </td>
                                                <td className="text-end">
                                                    ₹ {cgst.toFixed(2)}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="fw-bold text-end">
                                                    SGST (9%)
                                                </td>
                                                <td className="text-end">
                                                    ₹ {sgst.toFixed(2)}
                                                </td>
                                            </tr>
                                        </>
                                    )}

                                    <tr className="table-secondary">
                                        <td className="fw-bold text-end">
                                            TOTAL
                                        </td>
                                        <td className="fw-bold text-end">
                                            ₹ {total.toFixed(2)}
                                        </td>
                                    </tr>
                                </tbody>

                            </table>

                        </div>

                        {/* Add More */}
                        <div className="mt-3">

                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={addMoreRow}
                            >
                                Add More
                            </button>

                        </div>





                        <div className="mt-3 mb-3">

                            {/* Create Work Order */}
                            <button
                                type="button"
                                className="btn btn-success"
                                onClick={handleCreateWorkOrder}
                            >
                                {
                                    isEdit
                                        ? "Update Work Order"
                                        : "Create Work Order"
                                }
                            </button>

                        </div>

                        {/* Footer */}
                        <div className="text-center fw-bold border p-2">
                            THANK YOU FOR YOUR BUSINESS!
                        </div>

                    </div>

                </div>

            </div>

        </Layout >
    );
};

export default WorkOrderCreate;


